import React from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";

type Props = {
  open: boolean;
  onClose: any;
  onConfirm?: any;
  buttonTexts?: {
    confirm: string;
    cancel?: string;
  };
  title?: string;
  description?: string;
};

export const ConfirmationModal = ({
  open,
  onClose,
  onConfirm,
  buttonTexts,
  title = "Are you sure you want to delete this item?",
  description,
}: Props) => {
  const [deleting, setDeleting] = React.useState(false);

  const handleConfirm = async () => {
    try {
      setDeleting(true);
      await onConfirm();
      setDeleting(false);
      onClose();
    } catch (error) {
      setDeleting(false);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      keepMounted
      sx={{
        zIndex: 9999,
      }}
    >
      <Box sx={{ padding: "0.5rem" }}>
        <DialogTitle
          sx={{
            fontSize: "18px",
            fontWeight: "600",
            color: "#000",
            alignItems: "center",
            lineHeight: "150%",
            textAlign: "center",
            padding: "1.5rem",
          }}
          id="alert-dialog-title"
        >
          {title}
        </DialogTitle>
        {description && (
          <DialogContent>
            <DialogContentText
              id="alert-dialog-description"
              sx={{
                fontSize: "14px",
                fontWeight: "400",
                color: "#000",
                lineHeight: "16.8px",
              }}
            >
              {description}
            </DialogContentText>
          </DialogContent>
        )}
      </Box>
      <DialogActions
        sx={{
          display: "flex",
          justifyContent: "center",
          gap: "1rem",
          padding: "1rem 0 1.5rem 0",
        }}
      >
        <Button
          size="large"
          disabled={deleting}
          onClick={onClose}
          sx={{
            background: "#FFFFFF",
            color: "#161458",
            boxShadow: "none",
            border: "1px solid #161458",
            height: "40px",
            padding: "0.5rem 1rem",
            borderRadius: "4px",
          }}
        >
          {buttonTexts?.cancel || "Cancel"}
        </Button>

        <Button
          size="large"
          onClick={handleConfirm}
          autoFocus
          disabled={deleting}
          sx={{
            background: "#00C385",
            color: "#FFF",
            boxShadow: "none",
            height: "40px",
            border: "0.5px",
            padding: "0.5rem 1rem",
            borderRadius: "4px",
          }}
        >
          {deleting ? "Please wait..." : buttonTexts?.confirm || "Confirm"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationModal;
